import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import api, { BACKEND_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function HsExtrasTab() {
  const { project } = useOutletContext();
  const { user } = useAuth();
  const [talks, setTalks] = useState([]);
  const [jsas, setJsas] = useState([]);
  const [obs, setObs] = useState([]);
  const [signIn, setSignIn] = useState([]);
  const [qr, setQr] = useState(null);

  async function load() {
    const [t, j, o, s, q] = await Promise.all([
      api.get("/toolbox-talks", { params: { project_id: project.id } }),
      api.get("/jsas", { params: { project_id: project.id } }),
      api.get("/observations", { params: { project_id: project.id } }),
      user?.role !== "Worker" ? api.get(`/projects/${project.id}/sign-in-register`) : Promise.resolve({data:[]}),
      user?.role !== "Worker" ? api.get(`/projects/${project.id}/qr-code`) : Promise.resolve({data:null}),
    ]);
    setTalks(t.data); setJsas(j.data); setObs(o.data);
    setSignIn(s.data || []); setQr(q.data);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [project.id]);

  async function quickToolbox() {
    const topic = window.prompt("Topic?"); if (!topic) return;
    await api.post("/toolbox-talks", { project_id: project.id, topic, key_points: [], notes: "", attendee_ids: [] });
    load();
  }
  async function quickObservation() {
    const d = window.prompt("What's the observation?"); if (!d) return;
    await api.post("/observations", { project_id: project.id, description: d, urgency: "Medium", type: "Hazard" });
    load();
  }
  async function closeObs(o) {
    const r = window.prompt("Resolution notes?") || ""; await api.post(`/observations/${o.id}/close`, { resolution: r }); load();
  }
  async function downloadPdf(path) {
    const r = await api.get(path, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  }
  async function downloadCsv(path, name) {
    const r = await api.get(path, { responseType: "blob" });
    const u = URL.createObjectURL(r.data); const a = document.createElement("a");
    a.href = u; a.download = name; a.click();
  }

  return (
    <div className="space-y-3" data-testid="hs-extras-tab">
      <div className="card">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-silver">Toolbox talks</h3>
          {user?.role !== "Worker" && <button className="btn-ghost text-sm" onClick={quickToolbox}>+ Quick toolbox talk</button>}
        </div>
        <table className="table"><thead><tr><th>Topic</th><th>Status</th><th>Signatures</th><th></th></tr></thead>
          <tbody>{talks.map(t=>(
            <tr key={t.id}><td>{t.topic}</td><td>{t.status}</td><td>{(t.signatures||[]).length}/{(t.attendee_ids||[]).length}</td>
              <td><a className="text-xs hub-link" href="#" onClick={e=>{e.preventDefault(); downloadPdf(`/toolbox-talks/${t.id}/pdf`);}}>PDF</a></td></tr>
          ))}
          {talks.length===0 && <tr><td colSpan="4" className="opacity-50">No toolbox talks yet.</td></tr>}</tbody></table>
      </div>

      <div className="card">
        <h3 className="text-silver mb-2">JSAs</h3>
        <table className="table"><thead><tr><th>Task</th><th>Status</th><th>Steps</th><th></th></tr></thead>
          <tbody>{jsas.map(j=>(
            <tr key={j.id}><td>{j.task_description}</td><td>{j.status}</td><td>{(j.steps||[]).length}</td>
              <td><a className="text-xs hub-link" href="#" onClick={e=>{e.preventDefault(); downloadPdf(`/jsas/${j.id}/pdf`);}}>PDF</a></td></tr>
          ))}
          {jsas.length===0 && <tr><td colSpan="4" className="opacity-50">No JSAs yet.</td></tr>}</tbody></table>
      </div>

      <div className="card">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-silver">Observations</h3>
          <button className="btn-ghost text-sm" onClick={quickObservation} data-testid="btn-report-obs">Report something on site</button>
        </div>
        <table className="table"><thead><tr><th>Type</th><th>Urgency</th><th>Description</th><th>Status</th><th></th></tr></thead>
          <tbody>{obs.map(o=>(
            <tr key={o.id}><td>{o.type}</td><td>{o.urgency}</td><td>{o.description}</td><td>{o.status}</td>
              <td>{user?.role !== "Worker" && o.status==="Open" && <button className="text-xs" onClick={()=>closeObs(o)}>Close</button>}</td></tr>
          ))}
          {obs.length===0 && <tr><td colSpan="5" className="opacity-50">No observations.</td></tr>}</tbody></table>
      </div>

      {qr && user?.role !== "Worker" && (
        <div className="card">
          <h3 className="text-silver mb-2">Site QR check-in</h3>
          <div className="text-sm">Public sign-in URL: <code className="text-silver">{window.location.origin}{qr.sign_in_url}</code></div>
          <table className="table mt-2"><thead><tr><th>Name</th><th>Company</th><th>Action</th><th>At</th></tr></thead>
            <tbody>{signIn.slice(0,20).map(s=>(<tr key={s.id}><td>{s.name}</td><td>{s.company||"—"}</td><td>{s.action}</td><td>{(s.at||"").slice(0,16).replace("T"," ")}</td></tr>))}
            {signIn.length===0 && <tr><td colSpan="4" className="opacity-50">No sign-ins yet.</td></tr>}</tbody></table>
          <a className="btn-ghost text-sm mt-2 inline-block" href="#" onClick={e=>{e.preventDefault(); downloadCsv(`/projects/${project.id}/sign-in-register.csv`, "sign_in_register.csv");}}>Download register CSV</a>
        </div>
      )}
    </div>
  );
}
